// Single source of truth for the user-facing version pill.
//
// This is incremented on every meaningful shipped change (in lockstep with
// the service-worker CACHE_NAME in /app/frontend/public/service-worker.js).
// The initial "1" reflects the shipped v1 Auth + Dashboard experience; the
// second number is the running deployment count.
//
// When you bump the SW cache (pharmacy-ops-shell-vNN), bump this too.
export const APP_VERSION = "v1.96";
